import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = { class: "overview row" }
const _hoisted_3 = { class: "col-6" }
const _hoisted_4 = { class: "table table-hover align-top" }
const _hoisted_5 = { class: "border-dark border-bottom pb-2" }
const _hoisted_6 = { class: "border-dark border-bottom" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  colspan: 2,
  class: "fw-bold small text-uppercase text-muted"
}
const _hoisted_10 = { class: "name" }
const _hoisted_11 = { class: "buttons" }
const _hoisted_12 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "edit", -1)
const _hoisted_14 = { class: "name" }
const _hoisted_15 = { class: "buttons" }
const _hoisted_16 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "edit", -1)
const _hoisted_18 = { class: "name" }
const _hoisted_19 = { class: "buttons" }
const _hoisted_20 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "edit", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_alert_error = _resolveComponent("alert-error")!
  const _component_base_placeholder_table = _resolveComponent("base-placeholder-table")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, null, {
    default: _withCtx(() => [
      _createElementVNode("header", _hoisted_1, [
        _createVNode(_component_BaseTitle, {
          title: this.title
        }, null, 8, ["title"]),
        _createVNode(_component_alert_error, {
          exceptions: this.exceptions,
          class: "mt-3"
        }, null, 8, ["exceptions"])
      ]),
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("table", _hoisted_4, [
            _createElementVNode("thead", _hoisted_5, [
              _createElementVNode("tr", _hoisted_6, [
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('name')), 1),
                _hoisted_7
              ])
            ]),
            _createElementVNode("tbody", null, [
              (!this.isReady)
                ? (_openBlock(), _createBlock(_component_base_placeholder_table, {
                    key: 0,
                    "n-cols": 2
                  }))
                : (!this.hasContentBlockLibs)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                      _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.$t('noContentFound')), 1)
                    ]))
                  : (this.isReady)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        (this.structureType === _ctx.LibraryStructureTypeEnum.ARTICLE_ABSTRACT)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(this.articleAbstractLibs, (articleAbstractLib) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: articleAbstractLib.code
                              }, [
                                _createElementVNode("td", _hoisted_10, _toDisplayString(articleAbstractLib.description), 1),
                                _createElementVNode("td", _hoisted_11, [
                                  _createElementVNode("div", _hoisted_12, [
                                    _createVNode(_component_router_link, {
                                      to: {name: 'library-overview', params: {cb_structure: _ctx.ContentBlockTypesEnum.TEXT_WITH_IMAGE, cb_type: 'LIB_EXT_ARTICLE_ABSTRACT', lib_type: articleAbstractLib.code}},
                                      class: "btn btn-icon btn-primary ms-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_13
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ])
                                ])
                              ]))
                            }), 128))
                          : _createCommentVNode("", true),
                        (this.structureType === _ctx.LibraryStructureTypeEnum.CONTENT_PAGE)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(this.contentPageLibs, (contentPageLib) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: contentPageLib.lib_code
                              }, [
                                _createElementVNode("td", _hoisted_14, _toDisplayString(contentPageLib.lib_name), 1),
                                _createElementVNode("td", _hoisted_15, [
                                  _createElementVNode("div", _hoisted_16, [
                                    _createVNode(_component_router_link, {
                                      to: {name: 'libraries-content-pages-overview', params: {page_type_code: contentPageLib.page_type_code, lib_code: contentPageLib.lib_code}},
                                      class: "btn btn-icon btn-primary ms-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_17
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ])
                                ])
                              ]))
                            }), 128))
                          : _createCommentVNode("", true),
                        (this.structureType === _ctx.LibraryStructureTypeEnum.CONTENT_BLOCK)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(this.contentBlockLibs, (contentBlockLib) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: contentBlockLib.library.code
                              }, [
                                _createElementVNode("td", _hoisted_18, _toDisplayString(contentBlockLib.library.description), 1),
                                _createElementVNode("td", _hoisted_19, [
                                  _createElementVNode("div", _hoisted_20, [
                                    _createVNode(_component_router_link, {
                                      to: {name: 'library-overview', params: {cb_structure: this.cbStructure, cb_type: contentBlockLib.content_block_type.code, lib_type: contentBlockLib.library.code}},
                                      class: "btn btn-icon btn-primary ms-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_21
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ])
                                ])
                              ]))
                            }), 128))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}